import { useSelectedCountry } from "@/context/SelectedCountryContext";
import { Plane, ArrowRight } from "lucide-react";

export default function CountryGate() {
  const { isLocked, countries, setSlug } = useSelectedCountry();

  // If already locked, render nothing — main app shows through.
  if (isLocked) return null;

  return (
    <div
      data-testid="country-gate"
      className="fixed inset-0 z-[100] overflow-y-auto bg-[#0F172A]/95 backdrop-blur-sm"
    >
      <div className="min-h-full flex items-start justify-center py-16 px-6 lg:px-12">
        <div className="max-w-5xl w-full bg-white rounded-sm shadow-2xl border border-[#E2E8F0] p-8 lg:p-14">
          {/* Header */}
          <div className="flex items-start gap-4 mb-10">
            <div className="w-12 h-12 rounded-sm bg-[#002FA7] text-white flex items-center justify-center shrink-0">
              <Plane className="w-6 h-6" strokeWidth={1.5} />
            </div>
            <div>
              <div className="overline mb-2">First, the destination</div>
              <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#0F172A]">
                Where are you flying?
              </h1>
              <p className="mt-3 text-[#475569] text-base lg:text-lg leading-relaxed max-w-2xl">
                Pick the country you&apos;re traveling to. We&apos;ll tailor every guide, checklist,
                quiz and local tip to that destination — no clutter from the other 11.
              </p>
            </div>
          </div>

          {/* Grid */}
          {countries.length === 0 ? (
            <div className="text-[#475569] py-12 text-center">Loading destinations…</div>
          ) : (
            <div
              className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3"
              data-testid="gate-country-grid"
            >
              {countries.map((c) => (
                <button
                  key={c.slug}
                  data-testid={`gate-country-${c.slug}`}
                  onClick={() => setSlug(c.slug)}
                  className="group flex flex-col items-start gap-2 p-4 rounded-sm border border-[#E2E8F0] bg-white hover:border-[#002FA7] hover:bg-[#EEF2FF] transition-all text-left"
                >
                  <span className="text-3xl leading-none">{c.flag}</span>
                  <span className="font-display font-bold text-[#0F172A] tracking-tight">
                    {c.name}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-[#475569] group-hover:text-[#002FA7]">
                    Start prep <ArrowRight className="w-3 h-3 transition-transform group-hover:translate-x-0.5" strokeWidth={2} />
                  </span>
                </button>
              ))}
            </div>
          )}

          <p className="mt-10 text-xs text-[#94A3B8] leading-relaxed border-t border-[#E2E8F0] pt-6">
            You can change this any time from the header pill (top-right). Universal sections —
            Civic Principles, About, Ask Sanskaar — work without a destination.
          </p>
        </div>
      </div>
    </div>
  );
}
